import { render, staticRenderFns } from "./NavbarLogin.vue?vue&type=template&id=4a4ae6b9&lang=pug&"
import script from "./NavbarLogin.vue?vue&type=script&lang=js&"
export * from "./NavbarLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4ae6b9')) {
      api.createRecord('4a4ae6b9', component.options)
    } else {
      api.reload('4a4ae6b9', component.options)
    }
    module.hot.accept("./NavbarLogin.vue?vue&type=template&id=4a4ae6b9&lang=pug&", function () {
      api.rerender('4a4ae6b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavbarLogin.vue"
export default component.exports